import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const StepNavigation = ({ currentStep, onStepClick }) => {
  const { t } = useLanguage();
  
  const steps = [
    { number: 1, label: t.step1Label },
    { number: 2, label: t.step2Label },
    { number: 3, label: 'Risultato' }
  ];

  const handleStepClick = (stepNumber) => {
    if (onStepClick && stepNumber < currentStep) onStepClick(stepNumber);
  };

  const progress = ((currentStep - 1) / (steps.length - 1)) * 100;

  return (
    <nav className="sticky top-0 bg-white z-10 py-2 border-b border-gray-100">
      <div className="max-w-2xl mx-auto px-4">
        {/* Labels row */}
        <div className="flex justify-between mb-1.5">
          {steps.map((step) => (
            <button
              key={step.number}
              onClick={() => handleStepClick(step.number)}
              disabled={step.number >= currentStep}
              className={`text-xs font-medium transition-colors ${
                currentStep === step.number
                  ? 'text-stocker-green font-bold'
                  : currentStep > step.number
                  ? 'text-stocker-green/70 cursor-pointer hover:text-stocker-green'
                  : 'text-gray-400'
              }`}
            >
              {step.number}. {step.label}
            </button>
          ))}
        </div>
        {/* Bar */}
        <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-stocker-green rounded-full transition-all duration-500 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </nav>
  );
};

export default StepNavigation;
